import { getConfig } from '../config'

export const getAppUrl = () => {
  const { isBrowser } = getConfig()
  if (!isBrowser) {
    throw new Error('[getAppUrl/client] getAppUrl can only be called in a browser context')
  }
  return window.location.origin
}
